<template>
  <div class="container">

    <!-- search bar and layout selection -->
    <div class="pp-toolbar pp-asset-search-bar">
      <InputTextField class="iconify pp-asset-search-input" v-model="query"/>
      <i class="input icon">search</i>
      <button class="button icon rect grid left" :class="{
        selected: mode === 'grid'
      }" @click="setMode('grid')"><i class="icon">view_module</i></button>
      <button class="button icon rect grid right" :class="{
        selected: mode === 'list'
      }" @click="setMode('list')"><i class="icon">toc</i></button>
      <button class="button icon rect" @click="refresh()" :disabled="loading" title="Reload assets">
        <Spinner style="width: 24px; height: 24px; margin-bottom: 4px; padding-left: 8px" v-if="loading"/>
        <i class="icon" v-else>refresh</i>
      </button>
    </div>
    <!-- search bar and layout selection -->

    <!-- list view -->
    <div v-if="mode ==='list'">
      <div v-if="isLoadingAssets" style="display: flex; align-items: center; flex-direction: column; padding-top: 5rem">
        <Spinner style="width: 64px; height: 64px"/>
        <div>Loading Demos</div>
      </div>
      <table class="asset-table">
        <tr v-for="(asset, index) in customAssets"
            v-bind:key="index"
            :class="{
           'asset-row': true,
           'active': customId == index
         }" @click="gotoCustom(asset, index)">
          <td class="row-image">
            <img :src='picture(asset)' v-if="picture(asset)" alt="">
          </td>
          <td class="row-title">{{asset.metadata.title}}</td>
          <td class="row-props">
            <ul>
              <li>Custom Configuration</li>
              <li v-if="asset.source.drmProtected">Protected</li>
              <li>{{asset.source.type|contentType}}</li>
            </ul>
          </td>
          <td class="row-url">{{asset.source.url}}</td>
        </tr>
        <tr v-for="(asset, index) in assets"
            v-bind:key="index + customAssets.length"
            :class="{
           'asset-row': true,
           'active': assetId == asset.id
         }" @click="goto(asset)">
          <td class="row-image">
            <img :src='picture(asset)' v-if="picture(asset)" alt="">
          </td>
          <td class="row-title">{{asset.title}}</td>
          <td class="row-props">
            <ul>
              <li v-if="asset.cfg.source.drmProtected">Protected</li>
              <li v-if="asset.live">Live</li>
              <li>{{asset.type}}</li>
            </ul>
          </td>
          <td class="row-url">{{asset.cfg.source.url}}</td>
        </tr>
      </table>
    </div>
    <!-- list view -->

    <!-- grid view -->
    <div class="asset-list" v-if="mode ==='grid'">
      <div class="asset" @click="addAsset()">
        <div class="asset-add-container">
          <div class="add-icon-container">
            <i class="icon add-icon">add_circle_outline</i>
          </div>
          <div class="asset-data" style="text-align: center">
            <ul class="asset-props">
              <li>Try your stream</li>
            </ul>
            <div class="asset-title">Add Custom Configuration</div>
          </div>
        </div>
      </div>

      <div v-if="isLoadingAssets" class="grid-loader" style="display: flex; align-items: center; justify-content: center;">
        <div style="display: flex; align-items: center; flex-direction: column;">
          <Spinner style="width: 64px; height: 64px"/>
          <div>Loading Demos</div>
        </div>
      </div>

      <div v-for="(asset, index) in customAssets"
           v-bind:key="index"
           :class="{
           'asset': true,
           'active': customId == index
         }" @click="gotoCustom(asset, index)">
        <div class="asset-image-container">
          <DummyThumbnail class="thumb"/>
          <img :src='picture(asset)' v-if="picture(asset)" alt="">
          <div class="overlay">
            <div class="play-icon">
              <PlayCircle/>
            </div>
            <div>Now playing</div>
          </div>
        </div>
        <div class="asset-data">
          <ul class="asset-props">
            <li>Custom Configuration</li>
            <li v-if="asset.source.drmProtected">Protected</li>
            <li>{{asset.source.type|contentType}}</li>
          </ul>
          <div class="asset-title">{{asset.metadata.title}}</div>
        </div>
      </div>

      <div v-for="(asset, index) in assets"
           v-bind:key="index + customAssets.length"
           :class="{
           'asset': true,
           'active': assetId == asset.id
         }" @click="goto(asset)">
        <div class="asset-image-container">
          <div class="asset-id" title="Asset ID">{{asset.id}}</div>
          <DummyThumbnail class="thumb"/>
          <img :src='picture(asset)' v-if="picture(asset)" alt="">
          <div class="overlay">
            <div class="play-icon">
              <PlayCircle/>
            </div>
            <div>Now playing</div>
          </div>
        </div>
        <div class="asset-data">
          <ul class="asset-props">
            <li v-if="asset.cfg.source.drmProtected">Protected</li>
            <li v-if="asset.live">Live</li>
            <li>{{asset.type}}</li>
          </ul>
          <div class="asset-title" :title="asset.title">{{asset.title}}</div>
        </div>

      </div>
      <div style="visibility: hidden" class="asset" v-if="(assets.length + customAssets.length + 1) % 2 !== 0"></div>
    </div>
    <!-- grid view -->

  </div>
</template>

<script>
import DummyThumbnail from '../assets/blue-file_simplified.svg';
import PlayCircle from '../../../submodules/prestoplay-web-ui-vue/src/style/assets/play-circle.svg';
import InputTextField from '../components/forms/InputTextField';
import Spinner from '../components/Spinner';
import { createPlayerConfig } from '../utils/player';

export default {
  name: 'page-demo-select',
  components: {
    Spinner,
    InputTextField,
    DummyThumbnail,
    PlayCircle
  },
  props: ['tempQuery'],
  emits: ['updateTempQuery'],
  computed: {
    loading () {
      return this.$store.state.assetdb.loading;
    },
    isLoadingAssets () {
      return this.loading && (!this.assets || this.assets.length === 0);
    },
    assets () {
      let all = this.$store.state.assetdb.assets;
      if (process.env.NODE_ENV === 'development') {
        all = all.concat(this.$store.state.static_assets.assets);
      }

      if (this.query) {
        const lc = this.query.toLowerCase();
        const contains = (s) => {
          return String(s).toLowerCase().indexOf(lc) !== -1;
        };
        return all.filter(a => {
          return contains('#' + a.id) || contains(a.title) || contains(a.type) || contains(a.cfg.source.url);
        });
      }
      return all;
    },
    customAssets () {
      const all = this.$store.state.assetdb.custom;
      if (this.query) {
        const lc = this.query.toLowerCase();
        const contains = (s) => {
          return String(s).toLowerCase().indexOf(lc) !== -1;
        };
        return all.filter(a => {
          return contains(a.metadata.title) || contains(a.source.type) || contains(a.source.url);
        });
      }
      return all;
    },
    token () {
      return this.$store.state.assetdb.token;
    },
    name () {
      return this.$store.state.assetdb.name;
    },
    mode () {
      return this.$store.state.assetdb.mode;
    }
  },
  watch: {
    $route (to, from) {
      this.assetId = this.$route.query.assetId;
      this.customId = this.$route.query.customId;
    },
    query (newVal) {
      this.$emit('updateTempQuery', newVal);
    }
  },
  data () {
    return {
      assetId: null,
      customId: null,
      query: this.tempQuery
    };
  },
  mounted () {
    this.assetId = this.$route.query.assetId;
    this.customId = this.$route.query.customId;

    const assetsLength = this.$store.state.assetdb.assets.length;
    if (assetsLength === 0) {
      this.refresh();
    }
  },
  methods: {
    refresh () {
      this.$store.dispatch('assetdb/refresh');
    },
    setMode (mode) {
      this.$store.dispatch('assetdb/mode', mode);
    },
    picture (asset) {
      if (!asset || !asset.poster) return null;
      let url = asset.poster.landscape || asset.poster.portrait;
      if (url) {
        url = url.replace(/^https?:\/\//, '//');
      }
      return url;
    },
    addAsset () {
      this.$router.push({
        name: 'player.config'
      });
    },
    goto (asset) {
      const rawConfigString = JSON.stringify(createPlayerConfig(asset.cfg, true));
      this.$router.push({
        name: 'player.stats',
        query: {
          cfg: btoa(rawConfigString),
          assetId: asset.id
        }
      });
    },
    gotoCustom (asset, index) {
      const rawConfigString = JSON.stringify(createPlayerConfig(asset, true));
      this.$router.push({
        name: 'player.stats',
        query: {
          cfg: btoa(rawConfigString),
          customId: index
        }
      });
    }

  }
};
</script>

<style scoped lang="scss">

  @import "../style/color_";

  $size-image-height: 170px;
  $size-container-height: $size-image-height + 70px;
  $size-container-width: 300px;

  .container {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  .asset-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    align-items: stretch;
    /*overflow: auto;*/
    /*height: calc(100vh - 510px);*/

    .play-icon {
      width: 84px;
      margin: auto;
      color: white;
      fill: white;
      padding-top: 5rem;
      padding-bottom: 1rem;
    }

    .asset-add-container {
      border: 2px dashed $color-secondary;
      border-radius: 5px;
      margin: 5px;
      /*height: 100%;*/
      height: calc(100% - 10px);
    }

    .add-icon {
      font-size: 64px;
      color: $color-secondary;
    }

    .add-icon-container {
      text-align: center;
      padding-top: 50px;
      padding-bottom: 25px;
    }

    .asset {
      cursor: pointer;
      width: $size-container-width;
      height: $size-container-height;
      margin: 16px;
      border: 1px solid $color-tertiary;
      border-radius: 5px;
      flex: 0 0 auto;

      overflow: hidden;
      position: relative;

      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
      transition: all 0.3s cubic-bezier(.25, .8, .25, 1);
    }

    .asset:hover {
      box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
    }

    .grid-loader {
      width: $size-container-width;
      height: $size-container-height;
      margin: 16px;
    }

    .asset-title {
      font-size: 1.3rem;
      padding-left: 1rem;
      padding-right: 1rem;
      /*margin-bottom: 8px;*/
    }

    .asset-props {
      padding: 1rem;
      padding-bottom: 0;
      font-size: 1.6rem;

      li {
        display: inline;
        white-space: nowrap;
        margin-right: 5px;
      }

      li:after {
        content: " \2022";
      }

      li:last-child:after {
        content: none;
      }
    }

    .asset-id {
      margin-top: 10px;
      padding: 10px;
      font-size: 14px;
      color: black;
      opacity: 0.6;
      font-style: italic;
      float: right;
    }

    .asset-id::before {
      content: '#';
      opacity: 0.4;
    }

    .asset-image-container {
      line-height: 0;
      font-size: 0;
      background-repeat: no-repeat;
      background-size: cover;
      width: 100%;
      max-height: $size-image-height;
      height: $size-image-height;

      position: relative;
    }

    .asset-data {
      height: 100%;
    }

    .thumb {
      max-width: 100%;
      max-height: 100%;
      width: 100%;
      height: 100%;
      object-fit: cover;
      padding: 2rem;

      position: absolute;
    }

    img {
      max-width: 100%;
      max-height: 100%;
      width: 100%;
      height: 100%;
      object-fit: cover;

      position: absolute;
    }

    .asset-url {
      max-width: 75%;
      font-family: monospace;
      overflow-wrap: break-word;
    }

    .asset-url-fullwidth {
      max-width: 100%;
    }

    .overlay {
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.5);
      color: white;
      display: none;

      line-height: 1;
      font-size: 1.6rem;
      text-align: center;

      position: absolute;

    }

    .asset.active .asset-data {
      background-color: $color-cl-red;
      color: $color-initial;
    }

    .asset.active .overlay {
      display: block;
    }
  }

  .asset-table {
    padding: 1rem;
  }

  .asset-row.active,
  .asset-row:hover {
    background-color: $color-tertiary;
  }

  .row-props {
    li {
      display: inline;
      white-space: nowrap;
      margin-right: 5px;
    }

    li:after {
      content: " \2022";
    }

    li:last-child:after {
      content: none;
    }
  }

  .asset-row {
    cursor: pointer;
    transition: all 0.3s cubic-bezier(.25, .8, .25, 1);
  }
  .row-url {
    overflow-wrap: anywhere;
    display: none;
  }

  @media (min-width: 600px) {
    .row-url {
      display: table-cell;
    }
  }
  .row-image {
    img {
      width: 32px;
      height: 32px;
      object-fit: contain;
    }
  }

  /*@media (min-width: 690px) {*/
  /*  .asset-list {*/
  /*    .asset {*/
  /*      !*width: 45%;*!*/
  /*    }*/

  /*    !*img {*!*/
  /*    !*  width: 90px;*!*/
  /*    !*}*!*/

  /*  }*/

  /*}*/

</style>
